import {load} from '@shopify/theme-sections';

import '../sections/tagalys-recommendations';
import '../sections/tagalys-vav';
import '../sections/tagalys-bab';

import hideMediaArrow from '../components/media-arrow';

const template = 'product';

function toggleTagalys(e) {
  const containers = document.querySelectorAll('.tagalys-toggle');
  const triggers = document.querySelectorAll('.tagalys-toggle-trigger');
  const selectedItem = e.getAttribute('data-item');

  for (let i = 0; i < containers.length; i++) {
    let element = containers[i];
    if (element.classList.contains(selectedItem)) {
      element.classList.add('active');
    } else {
      element.classList.remove('active');
    }
  }

  for (let i = 0; i < triggers.length; i++) {
    let element = triggers[i];
    if (element == e) {
      element.classList.add('active');
    } else {
      element.classList.remove('active');
    }
  }
}

// Handle size selection and button state management
function initSizeSelection() {
  const productSelector = document.querySelector('#product-selectors');
  const addToCartBtn = document.querySelector('.btn-cart.add-to-cart-btn');
  const selectSizeBtn = document.querySelector('.btn-cart.select-a-size');

  if (!productSelector) return;

  // Function to update button states
  const updateButtonStates = (hasSelection) => {
    if (addToCartBtn && selectSizeBtn) {
      if (hasSelection) {
        // Show "Add to bag" button, hide "Select a size" button
        addToCartBtn.classList.remove('hide');
        selectSizeBtn.classList.add('hide');
      } else {
        // Show "Select a size" button, hide "Add to bag" button
        addToCartBtn.classList.add('hide');
        selectSizeBtn.classList.remove('hide');
      }
    }
  };

  // Function to check if a valid size is selected
  const checkSelection = () => {
    const selectedValue = productSelector.value;
    const hasValidSelection = selectedValue && selectedValue !== '';
    return hasValidSelection;
  };

  // Initial state check
  updateButtonStates(checkSelection());

  // Handle change events (desktop and some mobile browsers)
  productSelector.addEventListener('change', (event) => {
    updateButtonStates(checkSelection());
  });

  // Handle input events (additional mobile support)
  productSelector.addEventListener('input', (event) => {
    updateButtonStates(checkSelection());
  });

  // Mobile-specific touch handling
  let touchStarted = false;

  productSelector.addEventListener(
    'touchstart',
    () => {
      touchStarted = true;
    },
    {passive: true},
  );

  productSelector.addEventListener(
    'touchend',
    () => {
      if (touchStarted) {
        // Small delay to ensure the value has updated
        setTimeout(() => {
          updateButtonStates(checkSelection());
        }, 100);
      }
      touchStarted = false;
    },
    {passive: true},
  );

  // Focus and blur events for additional mobile support
  productSelector.addEventListener('focus', () => {
    // Focus event handler
  });

  productSelector.addEventListener('blur', () => {
    // Check selection when focus is lost
    setTimeout(() => {
      updateButtonStates(checkSelection());
    }, 100);
  });

  // Polling as a fallback for problematic mobile browsers
  let lastValue = productSelector.value;
  const pollForChanges = () => {
    const currentValue = productSelector.value;
    if (currentValue !== lastValue) {
      lastValue = currentValue;
      updateButtonStates(checkSelection());
    }
  };

  // Poll every 500ms while the selector might be active
  let pollInterval;

  productSelector.addEventListener('mousedown', () => {
    pollInterval = setInterval(pollForChanges, 500);
  });

  productSelector.addEventListener(
    'touchstart',
    () => {
      pollInterval = setInterval(pollForChanges, 500);
    },
    {passive: true},
  );

  const stopPolling = () => {
    if (pollInterval) {
      clearInterval(pollInterval);
      pollInterval = null;
      // Final check after stopping
      setTimeout(() => {
        updateButtonStates(checkSelection());
      }, 200);
    }
  };

  document.addEventListener('click', stopPolling);
  document.addEventListener('touchend', stopPolling, {passive: true});
}

export default (function () {
  if (document.body.dataset.template.includes(template) == false) return;

  // Initialize size selection handling
  initSizeSelection();

  // Handle product form submit -> add product to cart
  const productForm = document.querySelector('[data-product-form]');
  const formElements = productForm?.elements;

  productForm?.addEventListener('submit', (event) => {
    event.preventDefault();

    const variantID = formElements['id']?.value;
    const quantity = formElements['quantity']?.value ?? 1;

    if (!variantID) return;

    const item = {
      id: variantID,
      quantity: quantity,
    };
    window.sideCart.handleAddToCartEvent(item, true);
  });

  document.querySelector('.btn-cart.inactive')?.addEventListener('click', () => {
    const sizeSelector = document.querySelector('.select-size-message');
    sizeSelector.classList.remove('hide');

    setTimeout(() => {
      sizeSelector.classList.add('hide');
    }, 5000);
  });

  document.querySelector('.size-chart')?.addEventListener('click', () => {
    const sizeBestFitsCol = document.querySelector(
      '.product-measurements .table-area tbody tr:first-child td:nth-child(2)',
    );

    if (sizeBestFitsCol.textContent === 'Best Fits') {
      document.querySelector('.table-area').classList.add('static-col');
    }
  });

  load('*');

  hideMediaArrow();

  const triggers = document.querySelectorAll('.tagalys-toggle-trigger');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => toggleTagalys(e.target));
  });
})();
